import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { isPrelaunch } from '../data/launch';

/**
 * Pre-launch route gates. Until launch day only the front page is publicly
 * accessible; login stays reachable so privileged accounts can sign in.
 * Admins and accounts flagged with `prelaunch_access` (e.g. the prospective-
 * investor evaluation login) bypass the lockdown and see the full site —
 * everything scheduled for activation on launch day — except that admin
 * functions remain role-gated as always. Signups/purchases stay blocked
 * server-side for everyone else.
 */

export function hasPrelaunchBypass(user) {
  return user?.role === 'admin' || user?.prelaunch_access === true;
}

// Public pages other than the front page redirect home before launch,
// unless the visitor is signed in with a bypass account.
export function PrelaunchPublicGate({ children }) {
  const { user, loading } = useAuth();
  if (!isPrelaunch()) return children;
  if (loading) return null; // don't bounce a bypass user mid-auth-check
  if (hasPrelaunchBypass(user)) return children;
  return <Navigate to="/" replace />;
}

// Authenticated areas are limited to bypass accounts before launch (used
// inside ProtectedRoute, so `user` is already resolved).
export function PrelaunchMemberGate({ children }) {
  const { user } = useAuth();
  if (isPrelaunch() && !hasPrelaunchBypass(user)) return <Navigate to="/" replace />;
  return children;
}
